import { render, staticRenderFns } from "./ModalWaiting.vue?vue&type=template&id=58b17931&scoped=true"
import script from "./ModalWaiting.vue?vue&type=script&lang=js"
export * from "./ModalWaiting.vue?vue&type=script&lang=js"
import style0 from "./ModalWaiting.vue?vue&type=style&index=0&id=58b17931&prod&lang=scss"
import style1 from "./ModalWaiting.vue?vue&type=style&index=1&id=58b17931&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b17931",
  null
  
)

export default component.exports